//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import classnames from 'classnames';
import { EnhancedField } from 'common/components/core/form/Field';
import { Section } from 'common/entity/generic/SingleEntityEditView';
import theme from './ResourceLimitInput.scss';
import type { TFunction } from 'react-i18next';
import { MlFontIcon } from 'common/components/core/font_icon';

type Props = {
    resourceLimit: any,
    label: string,
    resourceName: string,
    unit: string,
    lowerThreshPlaceHolder: string,
    higherThreshPlaceHolder: string,
    rightIcon: string,
    rightIconColor: string,
    handleRightIconClick: Function,
    theme: Object,
    t: TFunction,
    testId?: {
        minInput: string,
        maxInput: string
    },
    onChange: Object => void
};

class ResourceLimitInput extends React.PureComponent<Props> {
    static defaultProps = {
        resourceName: '',
        label: '',
        lowerThreshPlaceHolder: '',
        higherThreshPlaceHolder: '',
        testId: {}
    };

    handleMaxChange = higherThresh => {
        const { onChange, resourceLimit } = this.props;
        const { lowerThresh } = resourceLimit;
        onChange({ name: this.getName(), higherThresh, lowerThresh });
    };

    handleMinChange = lowerThresh => {
        const { onChange, resourceLimit } = this.props;
        const { higherThresh } = resourceLimit;
        onChange({ name: this.getName(), higherThresh, lowerThresh });
    };

    handleRightIconClick = () => {
        const { handleRightIconClick } = this.props;
        handleRightIconClick?.(this.getName());
    };

    getTranslatedName = () => {
        const { resourceLimit, label } = this.props;
        const { name } = resourceLimit;
        return label || name;
    };

    getName = () => {
        const { resourceLimit, resourceName } = this.props;
        const { name } = resourceLimit;
        return name || resourceName;
    };

    getUnit = () => {
        const { unit } = this.props;
        return unit || this.getName();
    };

    render() {
        const {
            theme,
            resourceLimit,
            rightIcon,
            rightIconColor,
            t,
            testId,
            higherThreshPlaceHolder,
            lowerThreshPlaceHolder
        } = this.props;
        const { higherThresh, lowerThresh } = resourceLimit;
        const name = this.getName();
        const unit = this.getUnit();
        const translatedName = this.getTranslatedName();
        return (
            <div className={theme.fieldGroup}>
                <Section className={classnames(theme.row, theme.titleSection)}>
                    <span className={theme.label}>{translatedName}</span>
                    {rightIcon ? (
                        <MlFontIcon
                            bgColor={rightIconColor}
                            iconClass={rightIcon}
                            onClick={this.handleRightIconClick}
                            theme={theme}
                        />
                    ) : null}
                </Section>
                <Section className={theme.row}>
                    <div
                        className={classnames(
                            theme.fieldGroup,
                            theme.left,
                            theme.halfWidth
                        )}
                    >
                        <span className={theme.label}>
                            {t('riderForm.minResource', {
                                name: translatedName
                            })}
                        </span>
                        <EnhancedField
                            type="text"
                            element="input"
                            value={lowerThresh}
                            rightIcon={unit}
                            placeholder={lowerThreshPlaceHolder}
                            onChange={this.handleMinChange}
                            fieldId={name}
                            testId={testId.minInput}
                            theme={theme}
                            error={resourceLimit.getValidationMessage(
                                'lowerThresh'
                            )}
                        />
                    </div>
                    <div
                        className={classnames(
                            theme.fieldGroup,
                            theme.halfWidth
                        )}
                    >
                        <span className={theme.label}>
                            {t('riderForm.maxResource', {
                                name: translatedName
                            })}
                        </span>
                        <EnhancedField
                            type="text"
                            element="input"
                            value={higherThresh}
                            rightIcon={unit}
                            testId={testId.maxInput}
                            fieldId={name}
                            placeholder={higherThreshPlaceHolder}
                            onChange={this.handleMaxChange}
                            theme={theme}
                            error={resourceLimit.getValidationMessage(
                                'higherThresh'
                            )}
                        />
                    </div>
                </Section>
            </div>
        );
    }
}

export default compose(
    themr('ResourceLimitInput', theme),
    translate('entityManagement')
)(ResourceLimitInput);
